module.exports = __webpack_public_path__ + "img/summer.8b0ea78d.svg";